export var WlmUrls;
(function (WlmUrls) {
    WlmUrls["Dashboard"] = "/dashboard";
    WlmUrls["Users"] = "/users";
    WlmUrls["Workflow"] = "/workflow/";
})(WlmUrls || (WlmUrls = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2xtLXVybHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ3bG0tdXJscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxPQUlYO0FBSkQsV0FBWSxPQUFPO0lBQ2YsbUNBQXdCLENBQUE7SUFDeEIsMkJBQWdCLENBQUE7SUFDaEIsa0NBQXVCLENBQUE7QUFDM0IsQ0FBQyxFQUpXLE9BQU8sS0FBUCxPQUFPLFFBSWxCIn0=